import FaqSection from '@/v2/components/sections/common/faq-section'
import ForWhoSection from '@/v2/components/sections/common/for-who-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  additionalServicesWeOfferSectionContent,
  benefitsOfShippingToStorageServicesSectionContent,
  faqSectionContent,
  forWhoSectionContent,
  heroSectionContent,
  howOurShippingToStorageServicesWorkSectionContent,
  promotionalBannerSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/shipping-to-storage-page'

interface ShippingToStoragePageProps {}

const ShippingToStoragePage: React.FC<ShippingToStoragePageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
        w-[350px] h-[197px] 
        lg:!w-[458px] lg:!h-[258px] 
        xl-min:!w-[744px] xl-min:!h-[458px]
      '
        btnClassName='xl-min:!w-[233px] lg-mn:w-[202px] xl-min:h-[50px] md-mn:w-[228px] w-[278px] h-[44px]'
        className='[&_p]:text-balance md-mn:[&_p]:text-left'
      />
      <ServiceTipsSectionSection
        isBgDark
        {...howOurShippingToStorageServicesWorkSectionContent}
        className={`
          [&>div>div:nth-of-type(2)]:md-mn:grid-cols-3 
          [&_article]:text-center
          [&_article_div]:w-full
          [&_h3]:text-center
          xl-min:[&_button]:!w-[311px]
          [&_button]:w-[278px]
          `}
      />
      <ServiceTipsSectionSection
        {...benefitsOfShippingToStorageServicesSectionContent}
        className='[&>div>div:nth-of-type(2)]:lg-mn:grid-cols-2 [&>div>div:nth-of-type(2)]:xl-min:!grid-cols-3'
      />
      <WhyWeSection isBgDark {...whyWeSectionContent} />
      <ForWhoSection {...forWhoSectionContent} />
      <WhyWeSection
        isBgDark
        {...additionalServicesWeOfferSectionContent}
        className='[&_article]:bg-transparent [&_article]:border-none'
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        className='xl-min:[&_button]:!w-[294px] md-mn:[&_button]:w-[254px] [&_button]:w-[266px]'
        imgClassName='xl-min:w-[515px] xl-min:h-[282px] w-[340px] h-[170px]'
      />
      <FaqSection {...faqSectionContent} isBgDark />
    </>
  )
}

export default ShippingToStoragePage
